import { render, staticRenderFns } from "./Documentos.vue?vue&type=template&id=71df6d6b&"
import script from "./Documentos.vue?vue&type=script&lang=js&"
export * from "./Documentos.vue?vue&type=script&lang=js&"
import style0 from "./Documentos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71df6d6b')) {
      api.createRecord('71df6d6b', component.options)
    } else {
      api.reload('71df6d6b', component.options)
    }
    module.hot.accept("./Documentos.vue?vue&type=template&id=71df6d6b&", function () {
      api.rerender('71df6d6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dte/vistas/Documentos.vue"
export default component.exports